import { UseDropdownItems } from "@/common/composition/dropdown-items";
import { watch } from "@vue/composition-api";
import { BaseAppScript, ScriptGroupHelper, ScriptThreatHelper } from "./models";
import { uniq } from "@/fp";

// filters

const [
  script_groups,
  selected_script_group,
  set_selected_script_group,
  update_groups,
] = UseDropdownItems(
  ["All", ...ScriptGroupHelper.list].map((name, index) => {
    return {
      id: name,
      name,
      selected: index === 0,
    };
  })
);

const [
  threat_items,
  selected_threat_item,
  set_selected_threat_item,
  update_threats,
] = UseDropdownItems(
  ["All", ...ScriptThreatHelper.list].map((name) => {
    return {
      id: name,
      name,
      selected: false,
    };
  })
);

export const init_filters = (
  on_change: (new_filters_state: { threat: string; group: string }) => void
) => {
  const unwatch = watch([selected_script_group, selected_threat_item], (f) => {
    const [threat, group] = f.map((d) => d!.name);
    on_change({ threat, group });
  });

  const filter = (arr: BaseAppScript[]): BaseAppScript[] => {
    return arr.filter((s) => {
      if (selected_threat_item.value?.id !== "All") {
        const has_threat = [...s.threats, ...s.cascading_threats].includes(
          // @ts-ignore
          selected_threat_item.value!.id
        );
        if (!has_threat) {
          return false;
        }
      }

      if (selected_script_group.value?.id !== "All") {
        if (selected_script_group.value!.id !== s.group) {
          return false;
        }
      }

      return true;
    });
  };

  return {
    filters: {
      threat: {
        items: threat_items,
        selected: selected_threat_item,
        set: set_selected_threat_item,
        update: (scripts: BaseAppScript[]) => {
          const threats_arr = uniq(
            scripts.reduce(
              (acc, item) => {
                return acc.concat(item.cascading_threats, item.threats);
              },
              ["All"] as string[]
            )
          );
          update_threats(
            threats_arr.map((threat_name) => {
              return {
                id: threat_name,
                name: threat_name,
                selected: false,
              };
            })
          );
          set_selected_threat_item("All");
        },
      },
      group: {
        items: script_groups,
        selected: selected_script_group,
        set: set_selected_script_group,
        update: (scripts: BaseAppScript[]) => {
          const groups = uniq(["All", ...scripts.map((d) => d.group)]);
          update_groups(
            // @ts-ignore
            groups.map((group) => {
              return {
                id: group,
                name: group,
                selected: false,
              };
            })
          );
          set_selected_script_group("All");
        },
      },
    },
    filter,
    destroy_filters: unwatch,
  };
};
